export default "__VITE_ASSET__DRED6lFy__"